import { View } from 'foundations-components/components/View';
import { useCardContextValue } from '../state/CardContext';
import PropertyInputWrapper from './PropertyInputWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertiesList = ({
  isEditable = true
}) => {
  const {
    propertyNames
  } = useCardContextValue();
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "100",
    children: propertyNames.map(name => /*#__PURE__*/_jsx(PropertyInputWrapper, {
      propertyName: name,
      isEditable: isEditable
    }, name))
  });
};
export default PropertiesList;